let wakeLock = null;
let wantAwake = false;

const acquire = async () => {
  if (!wantAwake || wakeLock || !("wakeLock" in navigator) || document.visibilityState !== "visible") return;
  try {
    wakeLock = await navigator.wakeLock.request("screen");
    wakeLock.addEventListener("release", () => { wakeLock = null; });
  } catch (e) {
    wakeLock = null;
  }
};

document.addEventListener("visibilitychange", acquire);
document.addEventListener("contextmenu", (e) => {
  if (!e.target.closest?.("input, textarea")) e.preventDefault();
});
window.__sporeDevice = { wakeLockActive: () => Boolean(wakeLock), wantAwake: () => wantAwake };

export const keepAwake = (on) => {
  wantAwake = on;
  if (on) return acquire();
  try {
    wakeLock?.release();
  } catch (e) {
    /* ignore */
  }
  wakeLock = null;
};

// Fullscreen then landscape lock; both optional and never throw.
export const enterKiosk = async () => {
  try {
    const el = document.documentElement;
    if (!document.fullscreenElement && el.requestFullscreen) await el.requestFullscreen({ navigationUI: "hide" });
  } catch (e) {
    /* fullscreen refused */
  }
  try {
    await window.screen.orientation?.lock?.("landscape");
  } catch (e) {
    /* orientation lock unsupported */
  }
};
